// extracted by mini-css-extract-plugin
export default {"pagination_container":"paginationComp_pagination_container__+RQWa"};